import React from "react";
import loading from "../assets/loading.svg";

const Loading = () => (
  <div className="flex items-center justify-center min-h-screen bg-gray-100">
    <div className="text-center">
      <img
        src={loading}
        alt="Loading"
        className="w-16 h-16 animate-spin mx-auto"
      />
      <p className="mt-4 text-gray-600">Loading...</p>
    </div>
  </div>
);

export default Loading;